import type { FeatureItem } from './types';

export function MajorFeatureCard({ icon: Icon, title, description }: FeatureItem) {
  return (
    <div className="flex h-full flex-col gap-4 rounded-xl border border-border bg-card p-5 transition-colors hover:border-border/80 hover:bg-card/80">
      <div className="flex items-start gap-4">
        <div className="shrink-0 rounded-lg bg-muted p-2.5">
          <Icon className="h-5 w-5 text-foreground" />
        </div>
        <p className="pt-1 text-sm font-semibold leading-snug text-foreground">{title}</p>
      </div>
      <p className="text-sm leading-relaxed text-muted-foreground">{description}</p>
    </div>
  );
}

export function MinorFeatureRow({ icon: Icon, title, description }: FeatureItem) {
  return (
    <div className="flex items-start gap-3 py-2.5">
      <div className="mt-0.5 shrink-0 rounded-md bg-muted/60 p-1.5">
        <Icon className="h-3.5 w-3.5 text-muted-foreground" />
      </div>
      <div className="min-w-0">
        <span className="text-sm font-medium text-foreground/80">{title}</span>
        <span className="text-sm text-muted-foreground/70"> — {description}</span>
      </div>
    </div>
  );
}
